import * as React from "react";
import * as moment from "moment";
import { MonthStatistics, Statistics } from "./StatsModel";
import MonthlyStatsView from "./MonthlyStatsView";

interface StatsProps {
  http: any;
}

interface StatsState {
  months: Array<MonthStatistics>;
}

export default class Stats extends React.Component<StatsProps, StatsState> {
  constructor(props) {
    super(props);
    this.state = {
      months: []
    };
  }

  parseDates(months: Array<any>) {
    return months.map(b => {
      return { ...b, month: moment(b.monthId) };
    });
  }

  componentDidMount() {
    this.props.http.loadStats().then(resp => {
      const typedResponse: Statistics = {
        ...resp,
        months: this.parseDates(resp.months)
      };
      this.setState({
        months: typedResponse.months
      });
    });
  }

  render() {
    return (
      <div>
        <h1>Statistics</h1>
        <h2>By month</h2>
        <MonthlyStatsView months={this.state.months} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/stats/Stats.tsx